import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
import { IFeedbackTransaction } from '../builders/plan_feedback_transaction_builder';
import { planFeedbackTransactionActionType } from './../builders/plan_feedback_transaction_type';
import { FeedbackSuggestedPlanModel } from './../models/feedback_suggested_plan_model';
import { ActionMessageStringStrategy } from './../strategies/action_message_string_strategy';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'feedbackAcceptDeclineRevokeHelper',
    function feedbackAcceptDeclineRevokeHelper(
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      $state: ng.ui.IStateService,
      acceptDeclinePlanFeedbacksCommand: ICommand,
      ngAPNotificationDelegate: INotificationDelegate
    ) {
      return (feedbacks: IFeedbackTransaction[], actionType: planFeedbackTransactionActionType) => {
        const actionMessageString = ActionMessageStringStrategy[actionType];
        return acceptDeclinePlanFeedbacksCommand(ngFeedbackSuggestedPlanModel.read().id, feedbacks, actionType)
          .then(() => {
            ngAPNotificationDelegate.success(`Successfully ${actionMessageString} suggestion.`);
          })
          .catch((error) => {
            const hasAdvisorRevokedChanges = error.status === 403;
            if (hasAdvisorRevokedChanges) {
              $state.go('my.planner.suggestions.advisor_revoked_changes');
            } else {
              ngAPNotificationDelegate.error(`Suggestion was unable to be ${actionMessageString}.`);
            }
          });
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/helpers/accept_decline_revoke_helper.ts